<template>
    <div class="point bg_white" v-show="show">
        <div class="header">
            <button type="create" v-if="this.role==='agent'" class="fr" @click="createEvent">新建</button>
            <button type="back" class="fr" @click="backEvent">返回</button>
        </div>
        <lists ref="lists" :data="lists" :listsStyle="listsStyle" :httpRequestData="httpRequestData" @deleteEvent="deleteEvent" @editEvent="editEvent"
               @onlineEvent="onlineEvent" @offlineEvent="offlineEvent" @doorEvent="doorEvent" @whiteListEvent="whiteListEvent" @statementEvent="statementEvent"></lists>
        <point-detail ref="pointDetail" @updateData="$refs.lists.updateData()"></point-detail>
    </div>
</template>

<script>
    import Lists from '@/components/Lists'
    import pointDetail from './pointDetail'
    import {mapGetters} from "vuex";

    export default {
        name: "point",
        components: {
            Lists, pointDetail
        },
        data() {
            return {
                show: false,
                project_id: null,
                lists: {
                    title: [{text: '点位名称'}, {text: '点位编号'}, {text: '点位地址'}, {text: '点位状态'}, {text: '当天流水',style:{color: '#4B4B4B'}}, {text: '柜门数量',style:{color: '#4B4B4B'}}, {text: '操作'}]
                },
                listsStyle: [
                    {width: '15%', textAlign: 'left'},
                    {width: '15%', textAlign: 'left'},
                    {width: '15%', textAlign: 'left'},
                    {width: '10%', textAlign: 'left'},
                    {width: '8%', textAlign: 'center', color: '#1890FF', event: 'statementEvent'},
                    {width: '8%', textAlign: 'center', color: '#1890FF', event: 'doorEvent'},
                    {width: '26%', textAlign: 'left', marginLeft: '3%'},
                ],
                httpRequestData: {
                    url: '/manage/point',
                    func: this.httpRequestHandle,
                    error: '获取点位信息出错',
                    auto: false
                },
            }
        },
        computed: {
            ...mapGetters({
                role: 'user/role'
            }),
        },
        methods: {
            init(id) {
                this.show = true;
                this.project_id = id;
                if(id !== undefined && id !== null){
                    this.$refs.lists.updateData({
                        project_id: this.project_id
                    });
                }
            },
            httpRequestHandle(data) {
                let operation = this.role === 'admin' || this.role === 'partner' ? {
                    arr: [
                        {text: '柜门', style: {color: '#1890FF'}, event: 'doorEvent'},
                        {text: '流水', style: {color: '#1890FF'}, event: 'statementEvent'},
                    ]
                } : {
                    arr: [
                        {text: '删除', style: {color: '#FF2118'}, event: 'deleteEvent'},
                        {text: '编辑', style: {color: '#1890FF'}, event: 'editEvent'},
                        {text: '上架', style: {color: '#1890FF'}, event: 'onlineEvent'},
                        {text: '下架', style: {color: '#1890FF'}, event: 'offlineEvent'},
                        {text: '白名单', style: {color: '#1890FF'}, event: 'whiteListEvent'},
                        // {text: '柜门', style: {color: '#1890FF'}, event: 'doorEvent'},
                        // {text: '查看流水', style: {color: '#1890FF'}, event: 'statementEvent'},
                    ]
                };
                return data.map(item =>{
                    return [
                        {text: item.name},
                        {text: item.no},
                        {text: item.address},
                        {text: this.$config.pointStatus.getBin(item.status)},
                        {text: item.turnover},
                        {text: item.doors.length},
                        operation
                    ]
                });
            },
            closeEvent() {
                this.show = false;
            },
            createEvent() {
                this.$refs.pointDetail.init('create',{project_id: this.project_id});
            },
            deleteEvent(data) {
                this.$delete({
                    title: '删除点位',
                    tooltipContent: '请输入当前点位名称以删除当前点位名称,数据将不可恢复，谨慎操作',
                    value: data.name,
                    confirm: () => {
                        this.$api.delete('/manage/point/' + data.id).then((data) => {
                            this.$alert.success({content: '删除成功'});
                            this.$refs.lists.updateData({
                                project_id: this.project_id
                            });
                        }).catch((error) => {
                            this.$alert.error({content: '删除失败'});
                        });
                    }
                })
            },
            editEvent(data) {
                this.$refs.pointDetail.init('edit',data);
            },
            onlineEvent(data) {
                this.$api.put('/manage/point_status/' + data.id, {
                    status: 1
                }).then((data) => {
                    this.$alert.success({content: '上架成功'});
                    this.$refs.lists.updateData({
                        project_id: this.project_id
                    });
                }).catch((error) => {
                    this.$alert.error({content: '上架失败'});
                });
            },
            offlineEvent(data) {
                this.$api.put('/manage/point_status/' + data.id, {
                    status: 0
                }).then((data) => {
                    this.$alert.success({content: '下架成功'});
                    this.$refs.lists.updateData({
                        project_id: this.project_id
                    });
                }).catch((error) => {
                    this.$alert.error({content: '下架失败'});
                });
            },
            doorEvent(data) {
                this.show = false;
                this.$emit('navigation','door',data.id)
            },
            whiteListEvent(data) {
                this.show = false;
                this.$emit('navigation','whiteList',data.id);
            },
            statementEvent(data) {
                this.show = false;
                this.$emit('navigation','statement',data.id,data.name);
            },
            backEvent() {
                this.show = false;
                this.$emit('navigation','project')
            }

        }
    }
</script>

<style scoped>
    .point {
        padding: 0 5px;
    }

    .point > .header {
        height: 80px;
    }

    .point > .header > button {
        margin-top: 20px;
        margin-right: 15px;
    }
</style>